import { Checkbox, Col, DatePicker, Form, Input, InputNumber, Row } from 'antd'
import useFetchSelect from '../../../../elements/Hooks/useFetchSelect'
import withFormItemView from 'form-item-view-hoc'
import { get, isEmpty } from 'lodash'
import React, { Fragment } from 'react'
import { compose } from 'recompose'
import CentersCascader from '../../../../elements/Cascader/CentersCascader'
import withLoadingSection from '../../../../elements/HOC/withLoadingSection'
import withSort from '../../../../elements/HOC/withSort'
import withSpinning from '../../../../elements/HOC/withSpinning'
import MultiCurrency from '../../../../elements/MultiCurrency'
import Currency from '../../../../elements/Select/Currency'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withSelectFetch from '../../../../elements/Select/withSelectFetch'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../../modules/FormItems'
import { boolVal, dateVal, findCascadersParents, numVal, strVal } from '../../../../modules/Utils'

const CustomFormItem = compose(withFormItemView)(Form.Item)
const { TextArea } = Input
const InvoicesType = compose(
  withSelectFetch({ dropdown: 'invoices', name: 'type' }),
  withSpinning,
  withSort
)(CustomSelect)

function InvoiceForm(props) {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = props.form
  const { invoice, view, centers } = props

  const isConfirmed = get(invoice, 'status') === 'Confirmed'

  console.log(invoice)
  const company = get(invoice, 'company._id', '')
  const { SelectData: LendersContractSelect } = useFetchSelect({
    url: `lenders/contracts/${company.replace('members/', '')}?type=bank`,
    dontFetch: isEmpty(company),
    dependencyArray: [company],
  })

  return (
    <Form>
      <Row>
        <Col span={12}>
          <CustomFormItem readOnly={view} label="Type" {...defaultFormItemLayout}>
            {getFieldDecorator('type', {
              initialValue: strVal(invoice, 'type'),
              rules: [
                {
                  required: true,
                  message: "Type Can't be Empty!",
                },
              ],
            })(<InvoicesType disabled={isConfirmed} placeholder="Type" />)}
          </CustomFormItem>
        </Col>
        <Col span={12}>
          <CustomFormItem display={strVal(invoice, 'date')} readOnly={view} label="Date" {...defaultFormItemLayout}>
            {getFieldDecorator('date', {
              initialValue: dateVal(invoice, 'date'),
              rules: [
                {
                  required: true,
                  message: "Date Can't be Empty!",
                },
              ],
            })(<DatePicker disabled={isConfirmed} style={{ width: '100%' }} placeholder="Date" />)}
          </CustomFormItem>
        </Col>
        <Col span={12}>
          <CustomFormItem readOnly={view} label="Title" {...defaultFormItemLayout}>
            {getFieldDecorator('title', {
              initialValue: strVal(invoice, 'title'),
              rules: [
                {
                  required: true,
                  message: "Title Can't be Empty!",
                },
              ],
            })(<Input disabled={isConfirmed} placeholder="Title" />)}
          </CustomFormItem>
        </Col>
        <Col span={12}>
          <CustomFormItem
            display={strVal(invoice, 'dueDate')}
            readOnly={view}
            label="Due Date"
            {...defaultFormItemLayout}>
            {getFieldDecorator('dueDate', {
              initialValue: dateVal(invoice, 'dueDate'),
              rules: [
                {
                  required: true,
                  message: "Due Date Can't be Empty!",
                },
              ],
            })(<DatePicker disabled={isConfirmed} style={{ width: '100%' }} placeholder="Due Date" />)}
          </CustomFormItem>
        </Col>
        <Col span={12}>
          <CustomFormItem readOnly={view} label="Bill To:" {...defaultFormItemLayout}>
            {getFieldDecorator('client.fn', {
              initialValue: strVal(invoice, 'client.fn'),
              rules: [
                {
                  required: true,
                  message: "Client Can't be Empty!",
                },
              ],
            })(<Input disabled={isConfirmed} placeholder="Client Billing Name" />)}
          </CustomFormItem>
        </Col>
        <Col span={12}>
          <CustomFormItem
            display={strVal(invoice, 'billDate')}
            readOnly={view}
            label="Bill Date"
            {...defaultFormItemLayout}>
            {getFieldDecorator('billDate', {
              initialValue: dateVal(invoice, 'billDate'),
            })(<DatePicker disabled={isConfirmed} style={{ width: '90%' }} placeholder="Bill Date" />)}
          </CustomFormItem>
        </Col>
        <Col span={12}>
          <CustomFormItem readOnly={view} label="Description" {...defaultFormItemLayout}>
            {getFieldDecorator('description', {
              initialValue: strVal(invoice, 'description'),
            })(<TextArea style={{ width: '90%' }} disabled={isConfirmed} placeholder="Description" />)}
          </CustomFormItem>
        </Col>
        <Col span={12}>
          <CustomFormItem label="Email Subject" {...defaultFormItemLayout}>
            {getFieldDecorator('issuance.subject', {
              initialValue: strVal(invoice, 'issuance.subject'),
            })(<Input style={{ width: '90%' }} placeholder="Email Subject" />)}
          </CustomFormItem>
        </Col>

        <Col span={12}>
          <CustomFormItem
            display={strVal(invoice, 'bank.title')}
            readOnly={view}
            label="Pay to"
            {...defaultFormItemLayout}>
            {getFieldDecorator('bank._id', {
              initialValue: strVal(invoice, 'bank._id'),
              rules: rules.select,
            })(<LendersContractSelect disabled={isConfirmed} valueAtr={'title'} placeholder={'Select a Company'} />)}
          </CustomFormItem>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Center">
            {getFieldDecorator('centers', {
              initialValue: findCascadersParents(centers, strVal(invoice, 'center._id')),
              rules: rules.select,
            })(
              <CentersCascader
                key={getFieldValue('company._id') || get(invoice, 'company._id')}
                company={getFieldValue('company._id') || get(invoice, 'company._id')}
                // category={'Profit'}
                style={{ width: '90%' }}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <CustomFormItem readOnly={view} label="Center Category" {...defaultFormItemLayout}>
            {getFieldDecorator('center.category', {
              initialValue: strVal(invoice, 'center.category'),
            })(<Input disabled={true} placeholder="Center Category" />)}
          </CustomFormItem>
        </Col>
        <Col span={12}>
          <Form.Item label="W/Tax Applicable" {...defaultFormItemLayout}>
            {getFieldDecorator('wtax.applicable', {
              initialValue: boolVal(invoice, 'wtax.applicable'),
              valuePropName: 'checked',
            })(<Checkbox disabled={isConfirmed} placeholder="W/Tax Applicable" />)}
          </Form.Item>
        </Col>
        {props.form.getFieldValue('wtax.applicable') && (
          <Fragment>
            <Col span={12}>
              <CustomFormItem readOnly={view} label="W/Tax" {...defaultFormItemLayout}>
                {getFieldDecorator('wtax.tax', {
                  initialValue: numVal(invoice, 'wtax.tax'),
                  rules: [
                    {
                      required: true,
                      message: "W/Tax Can't be Empty!",
                    },
                  ],
                })(<InputNumber disabled={isConfirmed} style={{ width: '100%' }} placeholder="W/Tax" />)}
              </CustomFormItem>
            </Col>

            <Col span={12}>
              <CustomFormItem readOnly={view} label="W/Tax Percentage" {...defaultFormItemLayout}>
                {getFieldDecorator('wtax.percentage', {
                  initialValue: numVal(invoice, 'wtax.percentage'),
                  rules: [
                    {
                      required: true,
                      message: "W/Tax Percentage Can't be Empty!",
                    },
                  ],
                })(<InputNumber style={{ width: '100%' }} placeholder="W/Tax Percentage" disabled={isConfirmed} />)}
              </CustomFormItem>
            </Col>
          </Fragment>
        )}
        <Col span={12}>
          <Form.Item label="Other Payment Applicable" {...defaultFormItemLayout}>
            {getFieldDecorator('otherPayment.applicable', {
              initialValue: boolVal(invoice, 'otherPayment.applicable'),
              valuePropName: 'checked',
            })(<Checkbox disabled={isConfirmed} placeholder="Other Payment Applicable" />)}
          </Form.Item>
        </Col>
        {props.form.getFieldValue('otherPayment.applicable') && (
          <Fragment>
            <Col span={12}>
              <CustomFormItem readOnly={view} label="Other Payment Conversion" {...defaultFormItemLayout}>
                {getFieldDecorator('otherPayment.conversion', {
                  initialValue: numVal(invoice, 'otherPayment.conversion'),
                  rules: [
                    {
                      required: true,
                      message: "Other Payment Conversion Can't be Empty!",
                    },
                  ],
                })(
                  <InputNumber
                    style={{ width: '100%' }}
                    disabled={isConfirmed}
                    placeholder="Other Payment Conversion"
                  />
                )}
              </CustomFormItem>
            </Col>

            <MultiCurrency
              doc={invoice}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                type: 'invoice',
              }}
            />

            <Col span={12}>
              <CustomFormItem readOnly={view} label="Other Payment (EX)" {...defaultFormItemLayout}>
                {getFieldDecorator('otherPayment.net', {
                  initialValue: numVal(invoice, 'otherPayment.net'),
                  rules: [
                    {
                      required: true,
                      message: "Other Payment Net Can't be Empty!",
                    },
                  ],
                })(<InputNumber style={{ width: '100%' }} placeholder="Other Payment Net" disabled={isConfirmed} />)}
              </CustomFormItem>
            </Col>

            <Col span={12}>
              <CustomFormItem readOnly={view} label="Other Payment (INC))" {...defaultFormItemLayout}>
                {getFieldDecorator('otherPayment.gross', {
                  initialValue: numVal(invoice, 'otherPayment.gross'),
                  rules: [
                    {
                      required: true,
                      message: "Other Payment INC Can't be Empty!",
                    },
                  ],
                })(<InputNumber style={{ width: '100%' }} placeholder="Other Payment Gross" disabled={isConfirmed} />)}
              </CustomFormItem>
            </Col>

            <Col span={12}>
              <CustomFormItem readOnly={view} label="Other Payment Tax" {...defaultFormItemLayout}>
                {getFieldDecorator('otherPayment.tax', {
                  initialValue: numVal(invoice, 'otherPayment.tax'),
                  rules: [
                    {
                      required: true,
                      message: "Other Payment Tax Can't be Empty!",
                    },
                  ],
                })(<InputNumber style={{ width: '100%' }} placeholder="Other Payment Tax" disabled={isConfirmed} />)}
              </CustomFormItem>
            </Col>
          </Fragment>
        )}
        <Col span={12}>
          <Form.Item label="Local Tax Applicable" {...defaultFormItemLayout}>
            {getFieldDecorator('localTax.applicable', {
              initialValue: boolVal(invoice, 'localTax.applicable'),
              valuePropName: 'checked',
            })(<Checkbox disabled={isConfirmed} placeholder="Local Tax Applicable" />)}
          </Form.Item>
        </Col>
        {props.form.getFieldValue('localTax.applicable') && (
          <Fragment>
            <Col span={12}>
              <CustomFormItem readOnly={view} label="Local Tax Currency" {...defaultFormItemLayout}>
                {getFieldDecorator('localTax.currency', {
                  initialValue: strVal(invoice, 'localTax.currency'),
                  rules: [
                    {
                      required: true,
                      message: "Local Tax Currency Can't be Empty!",
                    },
                  ],
                })(<Currency disabled={isConfirmed} placeholder="Local Tax Currency" />)}
              </CustomFormItem>
            </Col>
            <Col span={12}>
              <CustomFormItem readOnly={view} label="Currency Conversion" {...defaultFormItemLayout}>
                {getFieldDecorator('localTax.conversion', {
                  initialValue: numVal(invoice, 'localTax.conversion'),
                  rules: [
                    {
                      required: true,
                      message: "Currency Conversion Can't be Empty!",
                    },
                  ],
                })(<InputNumber style={{ width: '100%' }} disabled={isConfirmed} placeholder="Currency Conversion" />)}
              </CustomFormItem>
            </Col>
          </Fragment>
        )}
        <Col span={12}>
          <Form.Item label="Show Stock" {...defaultFormItemLayout}>
            {getFieldDecorator('pdf.showProduct', {
              initialValue: boolVal(invoice, 'pdf.showProduct'),
              valuePropName: 'checked',
            })(<Checkbox disabled={isConfirmed} placeholder="Show Stock" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Show Invoice Type" {...defaultFormItemLayout}>
            {getFieldDecorator('pdf.showInvoiceType', {
              initialValue: boolVal(invoice, 'pdf.showInvoiceType'),
              valuePropName: 'checked',
            })(<Checkbox disabled={isConfirmed} placeholder="show Invoice Type" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Partial Invoice" {...defaultFormItemLayout}>
            {getFieldDecorator('partial', {
              initialValue: boolVal(invoice, 'partial'),
              valuePropName: 'checked',
            })(<Checkbox disabled={isConfirmed} placeholder="Partial Invoice" />)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

InvoiceForm.propTypes = {}
InvoiceForm.defaultProps = { view: false }

export default compose(Form.create(), withLoadingSection)(InvoiceForm)
